(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function () {
  var AtlasCardWidget = /*#__PURE__*/function () {
    function AtlasCardWidget(params) {
      _classCallCheck(this, AtlasCardWidget);

      this.widget = params.widget;
      this.cards = this.widget.querySelectorAll('._a-card-block');
      this.length = this.cards.length;
      this.timerId = this.setThrottle();
      this.resized = true;
    }

    _createClass(AtlasCardWidget, [{
      key: "init",
      value: function init() {
        this.updateRadius();
        this.bindEvents();
      }
    }, {
      key: "columns",
      value: function columns() {
        var containerWidth = this.widget.clientWidth;
        var cardWidth = this.cards[0].clientWidth;
        return Math.round(containerWidth / cardWidth);
      }
    }, {
      key: "setRadius",
      value: function setRadius(card, radius) {
        card.style.borderRadius = "0px 0px ".concat(radius);
      }
    }, {
      key: "isDivisible",
      value: function isDivisible(num) {
        return Number.isInteger(num) ? true : false;
      }
    }, {
      key: "isEven",
      value: function isEven(num) {
        return num & 1 ? false : true;
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {
        var _this = this;

        window.addEventListener("resize", function () {
          if (_this.resized) {
            clearTimeout(_this.timerId);
            _this.timerId = _this.setThrottle();

            _this.updateRadius();

            _this.resized = false;
          }
        });
      }
    }, {
      key: "setThrottle",
      value: function setThrottle() {
        var _this2 = this;

        return setTimeout(function () {
          _this2.resized = true;
        }, 500);
      }
    }, {
      key: "resetRadius",
      value: function resetRadius() {
        for (var i = 0; i < this.cards.length; i++) {
          var card = this.cards[i];
          card.style.borderRadius = '0px';
        }
      }
    }, {
      key: "updateRadius",
      value: function updateRadius() {
        var length = this.length,
            cards = this.cards;
        var col = this.columns();
        var rows = Math.floor(length / col);
        var offset = rows * col;
        var lonelyItems = length - offset;
        var divisible = this.isDivisible(length / col);
        this.resetRadius(); // Handle 1 edge case

        if (col === 1 || length === 1) {
          // console.log('only one');
          this.setRadius(cards[length - 1], '8px 8px');
          return;
        } // Handle 2 edge case


        if (length === 2 && col >= 2) {
          // console.log('only 2');
          this.setRadius(cards[length - 1], '8px 0px');
          this.setRadius(cards[length - 2], '0px 8px');
          return;
        }

        if (divisible) {
          // console.log('divisible');
          this.setRadius(cards[length - 1], '8px 0px');
          this.setRadius(cards[length - col], '0px 8px');
          return;
        }

        if (lonelyItems > 1) {
          // console.log('2 of me');
          this.setRadius(cards[length - 1], '8px 0px');
          this.setRadius(cards[length - 1 - 1], '0px 8px');
          this.setRadius(cards[length - 1 - col - 1], '0px 8px');
          return;
        } else {
          // console.log('1 of me');
          this.setRadius(cards[length - 1], '8px 8px');
          this.setRadius(cards[length - 1 - col], '0px 8px');
          return;
        }
      }
    }]);

    return AtlasCardWidget;
  }();

  window.addEventListener('load', function () {
    var widgets = document.getElementsByClassName('_a-card-cont');

    if (widgets.length > 0) {
      for (var i = 0; i < widgets.length; i++) {
        var widget = widgets[i];
        new AtlasCardWidget({
          widget: widget
        }).init();
      }
    }
  });
})();

},{}],2:[function(require,module,exports){
"use strict";

(function () {
  window.addEventListener("DOMContentLoaded", function () {
    // Get all animatable elements
    var elements = document.querySelectorAll("._a-animate-el");

    if (elements !== undefined && elements !== null) {
      elements.forEach(function (element) {
        processAnimations(element);
      });
    }

    function processAnimations(element) {
      var settings = getAnimationSettings(element.getAttribute('atlas-animation-settings')); // constructAnimation(element, settings);

      constructTimeline(element, settings);
    }

    function constructTimeline(element, settings) {
      var _settings$animations = settings.animations,
          alpha = _settings$animations.alpha,
          scale = _settings$animations.scale,
          x = _settings$animations.x,
          y = _settings$animations.y;
      var delay = settings.delay,
          duration = settings.duration,
          ease = settings.ease;
      var tl = gsap.timeline({
        reversed: true,
        scrollTrigger: {
          trigger: element,
          toggleActions: "restart pause restart pause"
        }
      }); // console.log(element);

      tl.from(element, {
        duration: duration / 1000,
        ease: ease,
        delay: delay / 1000,
        alpha: alpha,
        scale: scale,
        x: x,
        y: y
      });
    }

    function getAnimationSettings(settings) {
      return JSON.parse(settings);
    }

    var rightFadeAnimations = document.querySelectorAll('._a-animate-right');

    if (rightFadeAnimations !== undefined && rightFadeAnimations !== null) {
      rightFadeAnimations.forEach(function (element) {
        getPredefinedRight(element);
      });
    }

    var leftFadeAnimations = document.querySelectorAll('._a-animate-left');

    if (leftFadeAnimations !== undefined && leftFadeAnimations !== null) {
      leftFadeAnimations.forEach(function (element) {
        getPredefinedLeft(element);
      });
    }

    function getPredefinedLeft(element) {
      var tl = gsap.timeline({
        reversed: true,
        scrollTrigger: {
          trigger: element,
          toggleActions: "restart pause restart pause"
        }
      }); // console.log(element);

      tl.from(element, {
        duration: 1,
        ease: "none.easeInOut",
        delay: 0.2,
        alpha: 0,
        x: -70
      });
    }

    function getPredefinedRight(element) {
      var tl = gsap.timeline({
        reversed: true,
        scrollTrigger: {
          trigger: element,
          toggleActions: "restart pause restart pause"
        }
      }); // console.log(element);

      tl.from(element, {
        duration: 1,
        ease: "none.easeInOut",
        delay: 0.3,
        alpha: 0,
        x: 70
      });
    }
  });
})();

},{}],3:[function(require,module,exports){
"use strict";

(function () {
  window.addEventListener("DOMContentLoaded", function () {});
})();

},{}],4:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PostExpander = /*#__PURE__*/function () {
  function PostExpander(params) {
    _classCallCheck(this, PostExpander);

    // this.animaion = null;
    this.expanded = false;
    this.activeItem = null;
    this.widget = params.widget;
    this.items = this.widget.querySelectorAll('.expander__item');
  }

  _createClass(PostExpander, [{
    key: "init",
    value: function init() {
      var _this = this;

      this.items.forEach(function (item) {
        _this.setHeight(item);
      });
      this.bindListeners();
    }
  }, {
    key: "bindListeners",
    value: function bindListeners() {
      var _this2 = this;

      window.addEventListener('resize', function () {
        _this2.resizeSentinel();
      });
    }
  }, {
    key: "setHeight",
    value: function setHeight(item) {
      var content = item.querySelector('.expander__item-content');
      var body = item.querySelector('.expander__item-body');
      var button = item.querySelector('.expander__item-button');
      var sentinel = item.querySelector('.expander__item-sentinel');
      var toggled = false; // let height = body.clientHeight;
      // const animation = gsap.timeline({ reversed: true });
      // animation.fromTo(sentinel, { duration: 0.6, height: 0 }, { height: content.clientHeight });
      // animation.fromTo(body, { duration: 0.6, height: 0 }, { height });

      button.addEventListener('click', function () {
        // !animation.reversed() ? animation.reverse() : animation.play();
        if (!toggled) {
          gsap.to(sentinel, {
            duration: 0.3,
            height: content.scrollHeight,
            onComplete: complete
          });
          toggled = true;
        } else {
          gsap.to(sentinel, {
            duration: 0.3,
            height: 0,
            onComplete: complete
          });
          toggled = false;
        }
      });
      window.addEventListener('resize', function (e) {
        if (toggled) {
          sentinel.style.height = content.scrollHeight + 'px';
        }
      });

      var complete = function complete() {
        window.dispatchEvent(new Event('resize'));
      };
    }
  }, {
    key: "resizeSentinel",
    value: function resizeSentinel() {
      if (this.activeItem === null) return; // console.log('res');
      // const content = this.activeItem.querySelector('.expander__item-content');
      // const sentinel = this.activeItem.querySelector('.expander__item-sentinel');
      // sentinel.style.height = content.scrollHeight + 'px';
    }
  }]);

  return PostExpander;
}();

var expanderWidgets = document.querySelectorAll('.expander__widget');

if (expanderWidgets !== null) {
  expanderWidgets.forEach(function (widget) {
    new PostExpander({
      widget: widget
    }).init();
  });
}

},{}],5:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function () {
  var AtlasPosts = /*#__PURE__*/function () {
    function AtlasPosts(params) {
      _classCallCheck(this, AtlasPosts);

      this.widget = params.widget;
      this.prefix = '._a-posts-list-';
      this.postsPerPage = this.widget.dataset.perPage;
      this.postsContainer = this.widget.querySelector('._a-posts-list-wrapper');
      this.currentPostCount = this.postsContainer.childElementCount;
      this.pagination = this.widget.dataset.pagination;
      this.filterable = this.widget.dataset.filterable;
      this.ajaxUrl = this.widget.dataset.ajaxUrl;
      this.hash = this.widget.querySelector('input[name="instance_hash"]').value;
      this.activeFilter = null;
      this.prev = null;
      this.next = null;
      this.year = null;
      this.fetching = false;
      this.page = 1;
    }

    _createClass(AtlasPosts, [{
      key: "init",
      value: function init() {
        this.setupPagination();
        this.setupYearFilter();
        this.resetStates();
      }
    }, {
      key: "getPostCount",
      value: function getPostCount() {
        if (this.currentPostCount === 0) return 0;
        return parseInt(this.postsContainer.children[0].dataset.postCount);
      }
    }, {
      key: "maxPagination",
      value: function maxPagination() {
        if (this.currentPostCount === 0) return 0;

        if (this.postsContainer.children.length === 0) {
          return 0;
        }

        return parseInt(this.postsContainer.children[0].dataset.maxPages);
      }
    }, {
      key: "setupPagination",
      value: function setupPagination() {
        var _this = this;

        var widget = this.widget,
            currentPostCount = this.currentPostCount,
            postsPerPage = this.postsPerPage,
            prefix = this.prefix;
        if (widget.dataset.pagination === "false" || currentPostCount === 0 || currentPostCount < postsPerPage) return;
        this.next = widget.querySelector(prefix + 'next');
        this.prev = widget.querySelector(prefix + 'prev'); // INCREMENT page counter BEFORE getting new posts

        this.next.addEventListener('click', function () {
          if (_this.page === _this.maxPagination()) return;
          _this.page++;

          _this.getPosts();
        });
        this.prev.addEventListener('click', function () {
          if (_this.page === 1) return;
          _this.page--;

          _this.getPosts();
        });
      }
    }, {
      key: "setupYearFilter",
      value: function setupYearFilter() {
        var _this2 = this;

        if (this.filterable === "false") return;
        var prefix = this.prefix;
        var filters = this.widget.querySelectorAll("".concat(prefix, "filter"));
        var activeClass = '_a-posts-list-curr-year';

        if (this.widget.dataset.yearly === "true" && this.activeFilter === null) {
          filters[0].classList.add(activeClass);
          this.activeFilter = filters[0];
        }

        filters.forEach(function (filter) {
          filter.addEventListener('click', function () {
            if (_this2.activeFilter === null || _this2.activeFilter !== filter) {
              filter.classList.add(activeClass);

              if (_this2.activeFilter !== null) {
                _this2.activeFilter.classList.remove(activeClass);
              }

              _this2.activeFilter = filter;
              _this2.year = filter.innerText;
              _this2.page = 1;

              _this2.getPosts();
            }
          });
        });
      }
    }, {
      key: "togglePaginationState",
      value: function togglePaginationState() {
        var pagination = this.pagination,
            next = this.next,
            prev = this.prev,
            prefix = this.prefix,
            page = this.page;
        var deactivatePagClass = '_a-posts-list-deactivate';
        if (!pagination || next === null) return; // If there's only one page then disable both and return

        if (this.maxPagination() === 1) {
          next.classList.add(deactivatePagClass);
          prev.classList.add(deactivatePagClass);
          return;
        }

        if (page === 1) {
          prev.classList.add(deactivatePagClass);
        } else {
          prev.classList.remove(deactivatePagClass);
        }

        if (page === this.maxPagination()) {
          next.classList.add(deactivatePagClass);
        } else {
          next.classList.remove(deactivatePagClass);
        }
      }
    }, {
      key: "getPosts",
      value: function getPosts() {
        // Dynamically evaluate data BEFORE query is constructed
        this.requestData();
        this.fadeWrapper('out');
      }
    }, {
      key: "resetStates",
      value: function resetStates() {
        this.togglePaginationState();
        this.fadeWrapper('in');
        setTimeout(function () {
          window.dispatchEvent(new Event('resize'));
        }, 200);
      }
    }, {
      key: "fadeWrapper",
      value: function fadeWrapper(state) {
        var opacity = state === 'in' ? 1 : 0;
        gsap.to(this.postsContainer, {
          duration: 0.5,
          autoAlpha: opacity
        });
      }
    }, {
      key: "requestData",
      value: function requestData() {
        var _this3 = this;

        var xhr = new XMLHttpRequest(),
            method = "GET",
            url = this.prepareQuery();
        xhr.open(method, url, true);

        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            _this3.postsContainer.innerHTML = JSON.parse(xhr.responseText).html;

            _this3.resetStates();
          }
        };

        xhr.send();
      }
    }, {
      key: "prepareQuery",
      value: function prepareQuery() {
        var ajaxUrl = this.ajaxUrl,
            hash = this.hash;
        var url = ajaxUrl + '&';
        var data = {
          action: 'atlas_posts_load',
          paged: this.page
        };

        if (this.year !== null) {
          data.year = this.year;
        }

        data.instance_hash = hash;
        var query = this.buildQuery(data);
        return url + query;
      }
    }, {
      key: "buildQuery",
      value: function buildQuery(data) {
        var query = [];

        for (var key in data) {
          if (data.hasOwnProperty(key)) {
            query.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(data[key])));
          }
        }

        return query.join('&');
      } // END CLASS

    }]);

    return AtlasPosts;
  }();

  var widgets = document.querySelectorAll('._a-posts-list-container');
  window.addEventListener("DOMContentLoaded", function () {
    if (widgets !== undefined) {
      for (var i = 0; i < widgets.length; i++) {
        var widget = widgets[i];
        new AtlasPosts({
          widget: widget
        }).init();
      }
    }
  });
})();

},{}],6:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function () {
  var TabWidget = /*#__PURE__*/function () {
    function TabWidget(params) {
      _classCallCheck(this, TabWidget);

      this.widget = params.widget;
      this.activeId = 0;
      this.settings = params.settings;
      this.tabsContainer = this.widget.querySelector('._a-tab-nav');
      this.tabs = this.widget.querySelectorAll('._a-tab');
      this.sentinel = this.widget.querySelector('._a-tab-sentinel');
      this.slides = this.widget.querySelectorAll('._a-tab-slide');
      this.panelsContainer = this.widget.querySelector('._a-tab-panels');
      this.panels = this.widget.querySelectorAll('._a-tab-panel');
      this.activeTab = null; // this.activeTab = this.tabs[0];

      this.resized = false;
      this.intervalId = null;
    }

    _createClass(TabWidget, [{
      key: "init",
      value: function init() {
        this.checkHash(); // Bind listeners

        this.bindListeners(); // Initialize height

        this.initializeHeight();
      }
    }, {
      key: "checkHash",
      value: function checkHash() {
        var _this = this;

        var hash = window.location.hash;

        if (hash == "") {
          this.toggle(this.tabs[0]);
          return;
        }

        this.tabs.forEach(function (tab) {
          if (tab.getAttribute('trigger-url') == hash) {
            _this.toggle(tab);
          }
        });
      }
    }, {
      key: "bindListeners",
      value: function bindListeners() {
        var _this2 = this;

        // Add click listener to each tab button
        this.tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            _this2.toggle(tab);
          });
        }); // Needs to be debounced properly

        window.addEventListener('resize', function () {
          _this2.resizeHeight();
        }); // Window location change 

        window.addEventListener('hashchange', function () {
          _this2.checkHash();
        });
      }
    }, {
      key: "toggle",
      value: function toggle(tab) {
        var id = parseInt(tab.getAttribute('trigger'));
        if (id === this.activeId) return; // console.log('active');

        window.location.hash = tab.getAttribute('trigger-url');
        tab.classList.toggle('active');
        this.tabs[this.activeId].classList.toggle('active');
        this.animate(id);
        this.activeId = id;
      }
    }, {
      key: "animate",
      value: function animate(id) {
        var _this$settings = this.settings,
            duration = _this$settings.duration,
            ease = _this$settings.ease;
        var panel = this.panels[id];
        var slide = this.slides[id];
        var activePanel = this.panels[this.activeId];
        var activeSlide = this.slides[this.activeId];
        gsap.to(activeSlide, {
          duration: duration,
          autoAlpha: 0
        });
        gsap.to(activePanel, {
          duration: duration,
          autoAlpha: 0
        });
        gsap.to(slide, {
          duration: duration,
          autoAlpha: 1
        });
        gsap.to(panel, {
          duration: duration,
          delay: duration,
          autoAlpha: 1
        });
        gsap.to(this.sentinel, {
          duration: duration,
          height: panel.clientHeight,
          ease: ease
        });
        panel.style.zIndex = '100'; // activePanel.style.zIndex = '0';
      }
    }, {
      key: "initializeHeight",
      value: function initializeHeight() {
        var _this3 = this;

        setTimeout(function () {
          _this3.animate(_this3.activeId);
        }, 500);
      }
    }, {
      key: "resizeHeight",
      value: function resizeHeight() {
        gsap.to(this.sentinel, {
          duration: 0.5,
          height: this.panels[this.activeId].offsetHeight
        });
      }
    }]);

    return TabWidget;
  }();

  window.addEventListener("DOMContentLoaded", function () {
    var widgets = document.querySelectorAll('._a-tab-container');

    if (widgets !== undefined && widgets !== null) {
      widgets.forEach(function (widget) {
        var settings = {
          duration: 0.6,
          ease: "none.out"
        };
        new TabWidget({
          widget: widget,
          settings: settings
        }).init();
      });
    }
  });
})();

},{}],7:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function () {
  var Ticker = /*#__PURE__*/function () {
    function Ticker(params) {
      _classCallCheck(this, Ticker);

      this.widget = params.widget;
      this.prefix = '_a-stock-ticker';
      this.arrow = this.widget.querySelector('.stockarrow');
      this.meta = this.widget.querySelector(".".concat(this.prefix, "-meta"));
      this.toggled = false;
      this.arrowTimeline = null;
      this.metaTimeline = null;
    }

    _createClass(Ticker, [{
      key: "init",
      value: function init() {
        this.metaAnimation();
        this.arrowAnimation();
        this.addListeners();
      }
    }, {
      key: "addListeners",
      value: function addListeners() {
        var _this = this;

        this.arrow.addEventListener('click', function () {
          _this.toggleArrow();
        });
      }
    }, {
      key: "arrowAnimation",
      value: function arrowAnimation() {
        var arrow = this.arrow;
        var arrowTl = gsap.timeline({
          reversed: true
        });
        var innerright = arrow.querySelector('#innerright'),
            innerleft = arrow.querySelector('#innerleft'),
            outerright = arrow.querySelector('#outerright'),
            outerleft = arrow.querySelector('#outerleft'),
            bg = arrow.querySelector('#arrowbg'),
            duration = 0.3;
        gsap.set([innerright, outerright], {
          transformOrigin: "left top"
        });
        gsap.set([innerleft, outerleft], {
          transformOrigin: "left bottom"
        });
        gsap.set(bg, {
          transformOrigin: "center"
        });
        arrowTl.to([innerright, outerright], {
          duration: duration,
          rotation: -90
        }, "start");
        arrowTl.to([innerleft, outerleft], {
          duration: duration,
          rotation: -90
        }, "start");
        arrowTl.to(arrow, {
          duration: duration,
          y: -25
        }, "start");
        arrowTl.to(bg, {
          duration: duration,
          y: 70
        }, "start");
        this.arrowTimeline = arrowTl;
      }
    }, {
      key: "metaAnimation",
      value: function metaAnimation() {
        var meta = this.meta;
        var metaTl = gsap.timeline({
          reversed: true
        }); // metaTl.set(meta, { display: 'none', autoAlpha: 0, height: 0 });

        metaTl.from(meta, {
          duration: 0.4,
          autoAlpha: 0,
          display: 'none',
          height: 0
        }); // metaTl.fromTo(meta, { duration: 0.4, autoAlpha: 0, display: 'none', height: 0 }, { duration: 0.4, autoAlpha: 1, display: 'flex', height: 'auto' });

        this.metaTimeline = metaTl;
      }
    }, {
      key: "toggleArrow",
      value: function toggleArrow() {
        var arrowTimeline = this.arrowTimeline,
            metaTimeline = this.metaTimeline;

        if (arrowTimeline.reversed()) {
          arrowTimeline.play();
          metaTimeline.play();
        } else {
          metaTimeline.reverse();
          arrowTimeline.reverse();
        }
      }
    }]);

    return Ticker;
  }();

  window.addEventListener("DOMContentLoaded", function () {
    var widgets = document.querySelectorAll('._a-stock-ticker-container');

    if (widgets !== null && widgets !== undefined) {
      widgets.forEach(function (widget) {
        new Ticker({
          widget: widget
        }).init();
      });
    }
  });
})();

},{}],8:[function(require,module,exports){
"use strict";

},{}],9:[function(require,module,exports){
"use strict";

require("../../extended-widgets/atlas-cards/assets/atlas-cards-script");

require("../../extended-widgets/atlas-content/assets/atlas-content-script");

require("./animate/atlas-animate");

require("../../extended-widgets/atlas-tabs/assets/atlas-tabs-script");

require("../../extended-widgets/atlas-posts/assets/atlas-posts-script");

require("../../extended-widgets/atlas-featured/assets/atlas-featured-script");

require("../../extended-widgets/atlas-ticker/assets/atlas-ticker-script");

require("../../extended-widgets/atlas-posts/assets/atlas-posts-expander");

},{"../../extended-widgets/atlas-cards/assets/atlas-cards-script":1,"../../extended-widgets/atlas-content/assets/atlas-content-script":2,"../../extended-widgets/atlas-featured/assets/atlas-featured-script":3,"../../extended-widgets/atlas-posts/assets/atlas-posts-expander":4,"../../extended-widgets/atlas-posts/assets/atlas-posts-script":5,"../../extended-widgets/atlas-tabs/assets/atlas-tabs-script":6,"../../extended-widgets/atlas-ticker/assets/atlas-ticker-script":7,"./animate/atlas-animate":8}]},{},[9]);
